<template>
  <div class="product-selection">
    <product-carousel />
    <amount-picker class="product-selection__amounts" />
    <!-- prodotto e taglio sono già nello store: alla CTA resta la sola navigazione -->
    <vb-button
      class="product-selection__cta"
      :vb_options="{
        text: `<strong>${cta_text}</strong>`,
        to: { name: 'checkout' },
        icon: 'g-card',
        variant: 'info',
        size: 'lg',
        block: true,
        disabled: !selected_amount,
      }"
    />
    <p class="product-selection__note">Il pagamento sarà gestito con il tuo credito welfare aziendale</p>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { checkout_cta_label } from '@livegift/resources';
  import ProductCarousel from '@livegift/components/blocks/homepage/product-carousel.vue';
  import AmountPicker from '@livegift/components/blocks/homepage/amount-picker.vue';

  export default {
    name: 'product-selection',

    components: {
      'product-carousel': ProductCarousel,
      'amount-picker': AmountPicker,
    },

    computed: {
      ...mapState('livegift', ['selected_amount']),

      cta_text() {
        return checkout_cta_label(this.selected_amount);
      },
    },
  };
</script>

<style lang="scss" scoped>

  .product-selection {

    &__amounts {
      display: block;
      margin-top: $grid-gutter-width;
    }

    &__cta{
      margin-top: $grid-gutter-width;

      @include livegift-cta-icon;
    }

    &__note {
      margin: ($grid-gutter-width / 2) 0 0;
      font-size: $font-size-sm;
      line-height: 18px;
      color: $gray-700;
      text-align: center;
    }
  }
</style>